(function($){

	// .c-pageHeaderにロゴがあった場合、ウインドウサイズ600以上のときにスタイルの都合上「.c-pageHeader__content」の外にだす　
	// $(function(){
	// 	var threshold = 600;
	//
	// 	$('.c-pageHeader').each(function(index, node){
	// 		var $node    = $(node);
	// 		var $logo    = $node.find('.c-pageHeader__logo');
	// 		var $content = $node.find('.c-pageHeader__content');
	//
	// 		if($logo.length === 0) return
	//
	// 		$(window).on('resize load', function(){
	//
	// 			var isSP     = window.matchMedia('screen and (max-width:'+ threshold +'px)').matches
	//
	// 			if(isSP) {
	// 				if(!$node.is('.is-sp')) {
	// 					$logo = $logo.insertBefore($content);
	// 				}
	// 				$node.addClass('is-sp');
	// 			} else {
	// 				if($node.is('.is-sp')) {
	// 					$logo = $logo.prependTo($content);
	// 					$node.removeClass('is-sp');
	// 				};
	// 			};
	// 		})
	// 	})
	// });

	// 高さ合わせ → いったん解除中
	// $(function(){
	// 	$('.c-iconGloup .c-iconGloup__item').matchHeight({
	//     byRow: true,
	//     property: 'height',
	//     target: null,
	//     remove: false
	// 	});
	// });

})(jQuery);
